import HeroSection from "@/components/HeroSection"
import AboutSection from "@/components/AboutSection"
import PurposeSection from "@/components/PurposeSection"
import EcosystemSection from "@/components/EcosystemSection"
import StatsSection from "@/components/StatsSection"
import AudienceSection from "@/components/AudienceSection"
import TestimonialsSection from "@/components/TestimonialsSection"
import TrustSection from "@/components/TrustSection"
import FAQSection from "@/components/FAQSection"
import VisionSection from "@/components/VisionSection"
import CoursesSection from "@/components/CoursesSection"
import LucyIASection from "@/components/LucyIASection"
import MethodologySection from "@/components/MethodologySection"

export default function Home() {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <PurposeSection />
      <EcosystemSection />
      <LucyIASection />
      <CoursesSection />
      <MethodologySection />
      <StatsSection />
      <AudienceSection />
      <TestimonialsSection />
      <TrustSection />
      <FAQSection />
      <VisionSection />
    </>
  )
}
